import { useEffect, useState } from 'react';
import { getExchangeRate, convertUsdToIls, formatIlsPrice } from '../utils/currency';

const DEFAULT_RATE = 3.15;

export function useCurrency() {
  const [rate, setRate] = useState<number>(DEFAULT_RATE);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getExchangeRate()
      .then(setRate)
      .finally(() => setIsLoading(false));
  }, []);

  const convert = (usdAmount: number): number => {
    return convertUsdToIls(usdAmount, rate);
  };

  const format = (usdAmount: number): string => {
    return formatIlsPrice(convert(usdAmount));
  };

  return {
    rate,
    isLoading,
    convert,
    format,
  };
}
